export const packageList = [
  {
    name: 'pms',
    activeRule: ['pms'],
  },
  {
    name: 'pms_common',
    activeRule: ['pms-common'],
  },
  {
    name: 'pms_operator',
    activeRule: ['pms-operator'],
  },
  {
    name: 'pms_report',
    activeRule: ['pms-report'],
  },
  {
    name: 'pms_operation_manage',
    activeRule: ['pms-operation-manage'],
  },
  {
    name: 'pms_business',
    activeRule: ['pms-business'],
  },
  {
    name: 'pms_paas',
    activeRule: ['pms-paas'],
  },
]

export const remoteModuleConfig = {
  dev: ['pms', 'pms_common', 'pms_operator', 'pms_report', 'pms_operation_manage', 'pms_business', 'pms_paas'],
  stg: ['pms', 'pms_common', 'pms_operator', 'pms_report', 'pms_operation_manage', 'pms_business', 'pms_paas'],
  uat: ['pms', 'pms_common', 'pms_operator', 'pms_report', 'pms_operation_manage', 'pms_business', 'pms_paas'],
  prd: ['pms', 'pms_common', 'pms_operator', 'pms_report', 'pms_operation_manage', 'pms_business', 'pms_paas'],
}



// WEBPACK FOOTER //
// ./src/layout/router/remote/package-list/pms/index.js